import { hotjarInit } from './lib/utils/hotjar';
import { Sentry } from '$lib/services/sentry';
import { getEnvironment } from '$lib/utils/environment';
import { getSentryConfig } from '$lib/services/sentry/config';
import { AppInitializationService } from '$lib/services/app-initialization';
import { initCrossTabLogoutListener } from '$lib/services/auth';

const environment = getEnvironment();

Sentry.init({
	...getSentryConfig({
		environment,
		// @ts-ignore
		release: __RELEASE_NAME__ || 'local',
		tracesSampleRate: 0.25,
	}),
	integrations: [
		Sentry.thirdPartyErrorFilterIntegration({
			filterKeys: ['testing-key'],
			behaviour: 'apply-tag-if-contains-third-party-frames',
		}),
	],
	allowUrls: [/https?:\/\/(?:www\.|web\.dev\.)?abcmouse\.com/],
});

export const handleError = Sentry.handleErrorWithSentry();

hotjarInit();

/**
 * Hook for client init
 */
export async function init() {
	initCrossTabLogoutListener();
	await AppInitializationService.initialize();
}
